<div class="fieldset title-area ">
    <legend>WorkBuddy</legend>
</div>

<div class="fieldset content-area">
    <div class="description description-title">Thank you for using the WorkBuddy.</div>
    <div class="description">Your tenant account is awaiting confirmation.</div>
    <div class="description">If you are the administrator, an invitation email would have been sent to your inbox. </div>

</div>
